// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_FlexColumn = require("./BrowserComponents_FlexColumn.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: Css.backgroundColor({
              NAME: "rgba",
              VAL: [
                0,
                0,
                0,
                0.25
              ]
            }),
        tl: {
          hd: BrowserStyle.height(BrowserStyle.vh(100.0)),
          tl: {
            hd: BrowserStyle.justifyContent(BrowserStyle.center),
            tl: {
              hd: BrowserStyle.left(BrowserStyle.zero),
              tl: {
                hd: BrowserStyle.position(BrowserStyle.absolute),
                tl: {
                  hd: BrowserStyle.top(BrowserStyle.zero),
                  tl: {
                    hd: BrowserStyle.width(BrowserStyle.vw(100.0)),
                    tl: {
                      hd: BrowserStyle.zIndex(Relude_Int.top),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  container: container
};

function BrowserComponents_WithModal$Content(Props) {
  var children = Props.children;
  return DomUtils.usePortal(React.createElement(BrowserComponents_FlexColumn.make, {
                  className: container,
                  children: children
                }));
}

var Content = {
  Styles: Styles,
  make: BrowserComponents_WithModal$Content
};

function BrowserComponents_WithModal(Props) {
  var children = Props.children;
  var getModalContent = Props.getModalContent;
  var match = ReactIO.useState(function (param) {
        
      });
  var setCurrentModal = match[1];
  var hideModal = Curry._1(setCurrentModal, undefined);
  var showModal = function (param) {
    return Relude_Globals.$great$great(Relude_Option.pure, setCurrentModal, param);
  };
  return React.createElement(React.Fragment, undefined, Curry._2(children, hideModal, showModal), Relude_Option.fold(null, (function (children) {
                    return React.createElement(BrowserComponents_WithModal$Content, {
                                children: children
                              });
                  }), Relude_Option.map(Curry._2(getModalContent, hideModal, showModal), match[0])));
}

var make = BrowserComponents_WithModal;

exports.Content = Content;
exports.make = make;
/* container Not a pure module */
